module.exports = __webpack_public_path__ + "img/g矩形 81@1x.cf74b977.png";